export default __webpack_public_path__ + "feature1c5ab1b.png";